/**
 * S3 Upload reducer
 * @module reducers/s3Upload
 */

import { UPLOAD_S3_FILE } from '../constants/ActionTypes';

const initialState = {
  subrequests: {},
};

/**
 * S3 Upload reducer
 * @function s3Upload
 * @param {Object} state Current state
 * @param {Object} action Action to be handled
 * @returns {Object} New state
 */
export default function s3Upload(state = initialState, action = {}) {
  switch (action.type) {
    case `${UPLOAD_S3_FILE}_PENDING`:
      return action.subrequest
        ? {
            ...state,
            subrequests: {
              ...state.subrequests,
              [action.subrequest]: {
                error: null,
                loaded: false,
                loading: true,
                data: null,
              },
            },
          }
        : {
            ...state,
            error: null,
            loaded: false,
            loading: true,
            data: null,
          };
    case `${UPLOAD_S3_FILE}_SUCCESS`:
      return action.subrequest
        ? {
            ...state,
            subrequests: {
              ...state.subrequests,
              [action.subrequest]: {
                error: null,
                loaded: true,
                loading: false,
                data: action.result,
              },
            },
          }
        : {
            ...state,
            error: null,
            loaded: true,
            loading: false,
            data: action.result,
          };
    case `${UPLOAD_S3_FILE}_FAIL`:
      return action.subrequest
        ? {
            ...state,
            subrequests: {
              ...state.subrequests,
              [action.subrequest]: {
                error: action.error,
                loaded: false,
                loading: false,
                data: null,
              },
            },
          }
        : {
            ...state,
            error: action.error,
            loaded: false,
            loading: false,
            data: null,
          };
    default:
      return state;
  }
}
